import type { Auth0ContextInterface } from '@auth0/auth0-react';
import { useMemo } from 'react';

import { resolveOktaIdpConfig } from './okta-idp-config';

type Auth0RedirectLoginOptions = NonNullable<
  Parameters<Auth0ContextInterface['loginWithRedirect']>[0]
>;

export type OktaLoginIntent =
  | {
      readonly kind: 'interactive';
    }
  | {
      readonly kind: 'redirect';
      readonly options: Auth0RedirectLoginOptions;
    };

const assertNever = (value: never): never => {
  throw new Error(`Unhandled Okta IdP config status: ${JSON.stringify(value)}`);
};

export const useOktaIdpInitiation = (
  auth0Organization: string | null,
  returnTo: string | null,
): OktaLoginIntent => {
  return useMemo(() => {
    const configResult = resolveOktaIdpConfig(auth0Organization, returnTo);

    switch (configResult.status) {
      case 'missing':
        return { kind: 'interactive' };
      case 'ready':
        return {
          kind: 'redirect',
          options: {
            authorizationParams: {
              organization: configResult.config.organization,
              scope: 'openid profile email',
            },
          },
        };
      default:
        return assertNever(configResult);
    }
  }, [auth0Organization, returnTo]);
};
